import * as React from "react";
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import { AppSidebar } from "./AppSidebar";
import { DashboardHeader } from "./DashboardHeader";
import { SiteFooter } from "./SiteFooter";

interface DashboardLayoutProps {
  children: React.ReactNode;
}

/**
 * DashboardLayout - Main layout wrapper for all dashboard pages
 *
 * Includes:
 * - AppSidebar for navigation
 * - DashboardHeader with breadcrumbs and user menu
 * - Main content area with proper padding
 * - SiteFooter with quiet credit line at the bottom
 */
export function DashboardLayout({ children }: DashboardLayoutProps) {
  return (
    <SidebarProvider defaultOpen={true}>
      <AppSidebar />
      <SidebarInset>
        <DashboardHeader />
        <main className="flex-1 p-4 md:p-6 lg:p-8">{children}</main>
        <SiteFooter />
      </SidebarInset>
    </SidebarProvider>
  );
}

export default DashboardLayout;
